<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-4 pb-0">
                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                LC Amendment Records
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="text-right">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/lc/import-lc-amendment-create')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Create Amendment
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="getLcImportLcAmendmentList"
                  :search="search"
                  :loading="loading"
                  item-value="id"
                  class="elevation-1"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:item.code="{ item }">
                    {{ item.code }}
                  </template>

                  <template v-slot:item.lc_master="{ item }">
                    {{ item.lcMaster?.lc_no || "N/A" }}
                  </template>

                  <template v-slot:item.amendment_no="{ item }">
                    {{ item.amendment_no }}
                  </template>

                  <template v-slot:item.amendment_date="{ item }">
                    {{ formatDateView(item.amendment_date) }}
                  </template>

                  <template v-slot:item.amendment_types="{ item }">
                    <v-chip
                      v-for="(type, idx) in getAmendmentTypes(item.amendment_types)"
                      :key="idx"
                      size="x-small"
                      color="primary"
                      variant="tonal"
                      class="mr-1"
                    >
                      {{ type }}
                    </v-chip>
                  </template>

                  <template v-slot:item.amendment_charge="{ item }">
                    {{ $numberFormat(item.amendment_charge || 0) }}
                  </template>

                  <template v-slot:item.approval_status="{ item }">
                    <v-chip
                      :color="getApprovalStatusColor(item.approval_status)"
                      size="small"
                      variant="tonal"
                    >
                      {{ item.approval_status || "Pending" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon="mdi-eye"
                      size="small"
                      variant="text"
                      color="info"
                      @click="viewItem(item.id)"
                    ></v-btn>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import { useField, useForm } from "vee-validate";
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";

export default {
  data: () => ({
    panel: [0],
    panel1: [0],
    search: "",
    headers: [
      { title: "#SL", align: "center", key: "index", width: "5%", sortable: false },
      { title: "Code", key: "code", align: "left", sortable: true },
      { title: "LC No", key: "lc_master", align: "left", sortable: false },
      { title: "Amendment No", key: "amendment_no", align: "left", sortable: true },
      { title: "Amendment Date", key: "amendment_date", align: "left", sortable: true },
      { title: "Amendment Types", key: "amendment_types", align: "left", sortable: false },
      { title: "Amendment Charge", key: "amendment_charge", align: "right", sortable: true },
      { title: "Approval Status", align: "center", key: "approval_status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false, width: "10%" },
    ],
  }),
  setup() {
    const { handleSubmit } = useForm();
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const store = useStore();
    const router = useRouter();
    const loading = ref(false);

    const getLcImportLcAmendmentList = computed(() => {
      return store.getters.getLcImportLcAmendmentList || [];
    });

    onMounted(() => {
      loadData();
    });

    const loadData = async () => {
      try {
        loading.value = true;
        await store.dispatch("getLcImportLcAmendmentList");
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to load LC Amendment records");
      } finally {
        loading.value = false;
      }
    };

    const submit = handleSubmit(async (values) => {
      await loadData();
    });

    const getAmendmentTypes = (types) => {
      if (!types) return [];
      try {
        return typeof types === 'string' ? JSON.parse(types) : types;
      } catch {
        return [];
      }
    };

    const getApprovalStatusColor = (status) => {
      const colors = {
        Pending: "warning",
        Approved: "success",
        Cancelled: "error",
      };
      return colors[status] || "warning";
    };

    const viewItem = (id) => {
      router.push({ path: `/lc/import-lc-amendment-view/${id}` });
    };

    const goTo = (val) => {
      router.push({ path: val }).catch((err) => {});
    };

    const exportToCSV = () => {
      toast.info("CSV export feature coming soon");
    };

    const exportToExcel = () => {
      toast.info("Excel export feature coming soon");
    };

    const exportToPDF = () => {
      toast.info("PDF export feature coming soon");
    };

    return {
      from_date,
      to_date,
      getLcImportLcAmendmentList,
      submit,
      viewItem,
      exportToCSV,
      exportToExcel,
      exportToPDF,
      loadData,
      getAmendmentTypes,
      getApprovalStatusColor,
      goTo,
      loading,
    };
  },
  methods: {
    formatDateView,
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>

